import { ArticleType, TravelCategory } from '@nemuru-eng/js-api-client';
import { z } from 'zod';

import { MinimalFormItemSchema } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/schemas/MinimalFormItemSchema';
import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { invalidNumberError, numberToString, requiredEnum, requiredFutureDate, requiredString } from '@/utils/zodUtils';

export const TravelFormItemSchema = (t: GetTextIdTranslationType) =>
  MinimalFormItemSchema(t).merge(
    z
      .object({
        type: z.literal(ArticleType.TRAVEL),
        description: z.string().optional(),
        optionalDescription: z.string().optional(),
        travelCategory: requiredEnum(TravelCategory, t),
        startDate: requiredFutureDate(t),
        endDate: requiredFutureDate(t),
        destination: requiredString(t),
        travellers: z
          .string()
          .optional()
          .pipe(z.coerce.number(invalidNumberError(t)))
          .refine((val) => !(val && Number(val) < 1), { message: t('AT_LEAST_ONE_TRAVELLER_ERROR') })
          .transform(numberToString)
          .optional()
          .transform((x) => (x === '0' ? undefined : x)),
      })
      .strict(),
  );
